import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 39,
  height: 39,
}

const Closet = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 38.5 38.425'
  >
    <g fill={color} transform='translate(0 -0.501)'>
      <path
        d='M93.621,83.632H94.8a.564.564,0,0,0,0-1.127H93.621a.564.564,0,0,0,0,1.127Z'
        transform='translate(-86.065 -75.843)'
      />
      <path
        d='M93.621,210.632H94.8a.564.564,0,0,0,0-1.127H93.621a.564.564,0,0,0,0,1.127Z'
        transform='translate(-86.065 -193.301)'
      />
      <path
        d='M93.621,337.632H94.8a.564.564,0,0,0,0-1.127H93.621a.564.564,0,0,0,0,1.127Z'
        transform='translate(-86.065 -310.758)'
      />
      <path
        d='M291.771,211.812a.563.563,0,0,0,.564-.564v-1.179a.564.564,0,0,0-1.127,0v1.179A.563.563,0,0,0,291.771,211.812Z'
        transform='translate(-269.327 -193.301)'
      />
      <path
        d='M439.223,210.069v1.179a.564.564,0,1,0,1.127,0v-1.179a.564.564,0,1,0-1.127,0Z'
        transform='translate(-406.222 -193.301)'
      />
      <path d='M37.486.5H12.525a.564.564,0,0,0,0,1.127H37.373V3.765H1.127V1.628H9.908A.564.564,0,0,0,9.908.5H1.014A1.016,1.016,0,0,0,0,1.515V3.878A1.016,1.016,0,0,0,1.014,4.892H1.5V32.383a1.139,1.139,0,0,0,.849,1.1V34.6A1.139,1.139,0,0,0,3.483,35.74h.466v2.066a1.121,1.121,0,0,0,1.12,1.12H6.42A1.113,1.113,0,0,0,7.5,38.1l.926-2.36h9.245a.564.564,0,1,0,0-1.127H3.483a.011.011,0,0,1-.011-.011V33.521H35.1V34.6a.011.011,0,0,1-.011.011H20.277a.564.564,0,1,0,0,1.127h9.872l.926,2.36a1.113,1.113,0,0,0,1.081.826h1.351a1.121,1.121,0,0,0,1.12-1.12V35.74h.466A1.139,1.139,0,0,0,36.231,34.6V33.476a1.139,1.139,0,0,0,.826-1.094V19.849a.564.564,0,1,0-1.127,0V32.383a.011.011,0,0,1-.011.011H25.936V4.894H35.93V17.247a.564.564,0,0,0,1.127,0V4.892h.429A1.016,1.016,0,0,0,38.5,3.878V1.515A1.016,1.016,0,0,0,37.486.5ZM5.076,35.74h2.14l-.777,1.982a.57.57,0,0,0-.024.077H5.076Zm8.591-3.346H2.634a.011.011,0,0,1-.011-.011v-8.4H13.667Zm0-9.542H2.623V14.437H13.667Zm0-9.542H2.623V4.894H13.667ZM24.789,32.394H14.794V4.894h9.994ZM33.5,37.8H32.161a.556.556,0,0,0-.024-.077l-.777-1.982H33.5Z' />
    </g>
  </svg>
)

export default Closet
